import { render, staticRenderFns } from "./EditarDadosAdministradorUnidade.vue?vue&type=template&id=79df2a64"
import script from "./EditarDadosAdministradorUnidade.vue?vue&type=script&lang=js"
export * from "./EditarDadosAdministradorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports